var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseMetis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25226 5.53438L0.867157 0.149279C0.668442 -0.0478017 0.347992 -0.0478017 0.149279 0.149279L0.149279 0.149279C-0.0489567 0.346385 -0.0498745 0.666872 0.147231 0.865108C0.147912 0.865793 0.148595 0.866476 0.149279 0.867157L5.53438 6.25226L0.149279 11.6374H0.149279C-0.0478018 11.8361 -0.0478018 12.1565 0.149279 12.3552H0.149279C0.346385 12.5535 0.666872 12.5544 0.865108 12.3573C0.865793 12.3566 0.866476 12.3559 0.867157 12.3552L6.25226 6.97014L11.6374 12.3552C11.8328 12.5507 12.1567 12.5532 12.3552 12.3552C12.5535 12.1581 12.5544 11.8376 12.3573 11.6394C12.3566 11.6387 12.3559 11.638 12.3552 11.6374L6.97014 6.25226L12.3552 0.867157V0.867157C12.5523 0.668442 12.5523 0.347993 12.3552 0.149279V0.149279C12.1581 -0.0489567 11.8376 -0.0498745 11.6394 0.147231C11.6387 0.147912 11.638 0.148595 11.6374 0.149279L6.25226 5.53438Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMetis);
export default __webpack_public_path__ + "static/media/close-metis.10c32623.svg";
export { ForwardRef as ReactComponent };